import { request } from './client'

export interface AuthSessionResult {
  token: string
  username?: string
  userName?: string
  email?: string
  [key: string]: unknown
}

export const getUserInfo = () => request({ url: '/patent/user/info', method: 'GET' })
export const mailLogin = (data: { email: string; password: string }) =>
  request<AuthSessionResult>({ url: '/patent/user/mailLogin', method: 'POST', data })
export const mailRegister = (data: Record<string, unknown>) =>
  request({ url: '/patent/user/mailRegister', method: 'POST', data })
export const changePassword = (data: Record<string, unknown>) =>
  request({ url: '/patent/user/changePass', method: 'POST', data })
/** 登录用户修改密码：发送邮箱验证码（依赖登录态，无需额外参数） */
export const sendChangePasswordCode = () =>
  request({ url: '/patent/user/send-change-password-code', method: 'POST' })
export const verifyChangePasswordCode = (data: { code: string }) =>
  request<{ verify_token?: string }>({
    url: '/patent/user/verify-change-password-code',
    method: 'POST',
    data,
  })
export const changeLoginUserPassword = (data: {
  verify_token: string
  new_password: string
  confirm_password: string
}) => request({ url: '/patent/user/change-password-login-user', method: 'POST', data })
export const sendCode = (data: Record<string, unknown>) =>
  request({ url: '/patent/system/sendEmail', method: 'POST', data })
export const logout = () => request({ url: '/patent/user/logout', method: 'POST' })
export const socialLogin = (provider: string, data: Record<string, unknown>) =>
  request({ url: `/patent/user/auth/${provider}/login`, method: 'POST', data })
export const socialLinkAccount = (data: Record<string, unknown>) =>
  request({ url: '/patent/user/auth/account-link-pc', method: 'POST', data })
export const socialCreateAccount = (data: Record<string, unknown>) =>
  request({ url: '/patent/user/auth/account-create-pc', method: 'POST', data })
export const getProviderInfo = (params: Record<string, unknown>) =>
  request({ url: '/patent/user/auth/get-provider-info', method: 'GET', params })
export const giftInfo = (params?: Record<string, unknown>) =>
  request({ url: '/patent/referrer/gift-info', method: 'GET', params })
export const verifyReferrer = (params: Record<string, unknown>) =>
  request({ url: '/patent/referrer/info', method: 'GET', params })
/** 登录用户绑定推荐码 */
export const bindReferrerCode = (data: { referrer_code: string }) =>
  request({ url: '/patent/user/bind-referrer-code', method: 'POST', data })

export interface ReferrerInfoResult {
  referrer_code?: string
  people_count?: number
  [key: string]: unknown
}

export interface ReferrerListItem {
  id?: number | string
  created_at?: string | number
  user?: { username?: string; [key: string]: unknown }
  [key: string]: unknown
}

/** 我的推荐信息：推荐码 + 推荐人数 */
export const getReferrerInfo = () =>
  request<ReferrerInfoResult>({ url: '/patent/user/referrer-info', method: 'GET' })

/** 推荐人列表 */
export const getReferrerList = (params: { page: number; limit: number }) =>
  request<{ list?: ReferrerListItem[]; page?: { total?: number } }>({
    url: '/patent/user/referrer-list',
    method: 'GET',
    params,
  })
